import { render, staticRenderFns } from "./DriverTicketList.vue?vue&type=template&id=0efc246c&scoped=true&"
import script from "./DriverTicketList.vue?vue&type=script&lang=js&"
export * from "./DriverTicketList.vue?vue&type=script&lang=js&"
import style0 from "./DriverTicketList.vue?vue&type=style&index=0&id=0efc246c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efc246c",
  null
  
)

export default component.exports